/* Northman: optional "Component brand preference" step (snippets/hk-brand-step.liquid). Not a variant option, not required.
 * - Choice -> line property "Component brand preference" (hidden input bound to the product form; disabled for No preference).
 * - Survives the Warehouse re-render of the picker block: the choice is kept per form id and restored in connectedCallback.
 * - Kit card: in each either-brand group (.hk-kc__either), the chip whose data-hk-brand matches gets "Your preference".
 */
(function () {
  if (customElements.get('hk-brand-pref')) return;
  var memo = {};
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function tagCard(v) {
    document.querySelectorAll('.hk-kc__either').forEach(function (g) {
      g.querySelectorAll('.hk-kc-chip').forEach(function (c) {
        var on = !!v && (c.getAttribute('data-hk-brand') || '').toLowerCase() === v.toLowerCase();
        c.classList.toggle('hk-kc-chip--pref', on);
        var t = c.querySelector('.hk-kc__preftag'); if (t) t.remove();
        if (on) { var sku = c.querySelector('.hk-kc-sku'); var html = '<span class="hk-kc__preftag">Your preference</span>'; if (sku) sku.insertAdjacentHTML('beforebegin', html); else c.insertAdjacentHTML('beforeend', html); }
      });
      var note = g.nextElementSibling;
      if (note && note.classList.contains('hk-kc__note')) {
        // one text box beside the icon, so the base note and the preference read as one flowing line
        var t = note.querySelector('[data-hk-note-t]');
        if (!t) { t = document.createElement('span'); t.className = 'hk-kc__note-t'; t.setAttribute('data-hk-note-t', '');
          Array.from(note.childNodes).forEach(function (n) { if (n.nodeName.toLowerCase() !== 'svg') t.appendChild(n); }); note.appendChild(t); }
        var x = t.querySelector('[data-hk-pref-note]'); if (x) x.remove();
        if (v) t.insertAdjacentHTML('beforeend', '<span data-hk-pref-note>. We\'ll aim for ' + esc(v) + '.</span>');
      }
    });
  }
  class HkBrandPref extends HTMLElement {
    connectedCallback() {
      this.formId = this.getAttribute('form-id');
      this.sel = this.querySelector('select[data-hk-brand-pref]');
      this.prop = this.querySelector('[data-hk-brand-prop]');
      if (!this.sel || !this.prop) return;
      var form = document.getElementById(this.formId);
      if (form && this.prop.getAttribute('form') !== form.getAttribute('id')) this.prop.setAttribute('form', form.getAttribute('id'));
      var v = memo[this.formId] || '';
      if (v && Array.from(this.sel.options).some(function (o) { return o.value === v; })) this.sel.value = v;
      this._onChange = this.apply.bind(this);
      this.sel.addEventListener('change', this._onChange);
      this.apply();
    }
    disconnectedCallback() { if (this.sel && this._onChange) this.sel.removeEventListener('change', this._onChange); }
    apply() {
      var v = this.sel.value || '';
      memo[this.formId] = v;
      this.prop.value = v; this.prop.disabled = !v;
      this.sel.classList.toggle('is-set', !!v);
      tagCard(v);
    }
  }
  customElements.define('hk-brand-pref', HkBrandPref);
})();
